var mp = mp || {};

// Slider - Hero
//-----------------------------------------------------------------
mp.sliderHero = function () {
    var $slider = $(".hero__slider .slider");

    if (!$slider.length) {
        return;
    }

    $slick = $slider.slick({
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        arrows: false,
        dots: false,
        speed: 1000,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        rows: 0,
        prevArrow:
            '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow:
            '<button type="button" class="slick-next slick-arrow"></button>',
    });
};

// Slider - Articles
//-----------------------------------------------------------------
mp.sliderArticles = function () {
    var $slider = $(".articles__slider .slider");

    if (!$slider.length) {
        return;
    }

    $slick = $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        fade: false,
        arrows: true,
        dots: false,
        speed: 1000,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: false,
        rows: 0,
        appendArrows: $(".articles__slider .arrows"),
        prevArrow:
            '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow:
            '<button type="button" class="slick-next slick-arrow"></button>',
        responsive: [
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 1,
                    variableWidth: false,
                },
            },
        ],
    });
};

$(document).ready(function () {
    mp.sliderHero();
    mp.sliderArticles();
});
